import styled from 'styled-components';
// LE ICONE DELLO SCENE EDITOR E DEL COMPOSER, da un punto solo: il rail, l'Outliner, le barre dei
// comandi, il viewport e le librerie importano da qui.
//
// SONO MATERIAL ICONS CLASSICHE (utente, 2026-10-02), le stesse del resto di Zakeke. Prima erano i
// glifi del prototipo, a tratto; la migrazione li ha portati tutti qui uno per uno, e chi importa
// non ha cambiato niente. L'unico glifo rimasto è «visibilità mista»: la classica non ha un occhio a
// metà, e lo stato misto non deve confondersi con acceso o spento.
//
// Le icone Material sono piene e senza colore proprio: `material()` le colora con `currentColor`,
// come facevano i glifi col tratto. Un `fill` nel CSS di chi le ospita vince comunque.
//
// NEVER give `eyeMixed.svg` a `width` or `height` attribute. SVGO drops the viewBox when it is
// redundant with them, and a glyph with no viewBox is drawn at 1:1 user units inside a 14 or 17
// pixel box. Size it from the CSS of whoever hosts it.

import React from 'react';
import AddSvg from 'src/shared/material_icons/content/add.svg';
import DeleteSvg from 'src/shared/material_icons/action/delete.svg';
import ContentCopySvg from 'src/shared/material_icons/content/content_copy.svg';
import EditSvg from 'src/shared/material_icons/image/edit.svg';
import MoreVertSvg from 'src/shared/material_icons/navigation/more_vert.svg';
import VisibilitySvg from 'src/shared/material_icons/action/visibility.svg';
import VisibilityOffSvg from 'src/shared/material_icons/action/visibility_off.svg';
import LockSvg from 'src/shared/material_icons/action/lock.svg';
import LockOpenSvg from 'src/shared/material_icons/action/lock_open.svg';
import ExpandMoreSvg from 'src/shared/material_icons/navigation/expand_more.svg';
import CloseSvg from 'src/shared/material_icons/navigation/close.svg';
import LinkSvg from 'src/shared/material_icons/content/link.svg';
import RestartAltSvg from 'src/shared/material_icons/device/restart_alt.svg';
import VtoSvg from 'src/shared/material_icons/legacy/VTO.svg';
import VideoCameraFrontSvg from 'src/shared/material_icons/image/video_camera_front.svg';
import LightbulbSvg from 'src/shared/material_icons/action/lightbulb.svg';
import VideocamSvg from 'src/shared/material_icons/av/videocam.svg';
import TextureSvg from 'src/shared/material_icons/image/texture.svg';
import WallpaperSvg from 'src/shared/material_icons/device/wallpaper.svg';
import ContrastSvg from 'src/shared/material_icons/image/contrast.svg';
import LayersSvg from 'src/shared/material_icons/maps/layers.svg';
import AutoAwesomeMotionSvg from 'src/shared/material_icons/image/auto_awesome_motion.svg';
import HighlightAltSvg from 'src/shared/material_icons/action/highlight_alt.svg';
import ViewInArSvg from 'src/shared/material_icons/action/view_in_ar.svg';
import FolderSvg from 'src/shared/material_icons/file/folder.svg';
import DriveFileMoveSvg from 'src/shared/material_icons/file/drive_file_move.svg';
import UploadSvg from 'src/shared/material_icons/file/upload.svg';
import DownloadSvg from 'src/shared/material_icons/file/download.svg';
import SaveSvg from 'src/shared/material_icons/content/save.svg';
import OpenInNewSvg from 'src/shared/material_icons/action/open_in_new.svg';
import SwapHorizSvg from 'src/shared/material_icons/action/swap_horiz.svg';
import NearMeSvg from 'src/shared/material_icons/maps/near_me.svg';
import OpenWithSvg from 'src/shared/material_icons/action/open_with.svg';
import RotateRightSvg from 'src/shared/material_icons/image/rotate_right.svg';
import OpenInFullSvg from 'src/shared/material_icons/action/open_in_full.svg';
import CenterFocusStrongSvg from 'src/shared/material_icons/image/center_focus_strong.svg';
import GridOnSvg from 'src/shared/material_icons/image/grid_on.svg';
import UnfoldMoreSvg from 'src/shared/material_icons/navigation/unfold_more.svg';
import UnfoldLessSvg from 'src/shared/material_icons/navigation/unfold_less.svg';
import PreviewSvg from 'src/shared/material_icons/action/preview.svg';
import FullscreenSvg from 'src/shared/material_icons/navigation/fullscreen.svg';
import FullscreenExitSvg from 'src/shared/material_icons/navigation/fullscreen_exit.svg';
import GridViewSvg from 'src/shared/material_icons/file/grid_view.svg';
import ViewListSvg from 'src/shared/material_icons/action/view_list.svg';
import FilterListSvg from 'src/shared/material_icons/content/filter_list.svg';
import LanguageSvg from 'src/shared/material_icons/action/language.svg';
import ViewDaySvg from 'src/shared/material_icons/action/view_day.svg';
import DeployedCodeSvg from './deployedCode.svg';

const material = (Svg: React.FunctionComponent<React.SVGAttributes<SVGElement>>) => {
    const MaterialIcon = (props: React.SVGAttributes<SVGElement>) => <Svg fill='currentColor' {...props} />;
    return MaterialIcon;
};

// I COMANDI: aggiungi, elimina, duplica, rinomina, «…», visibilità, lucchetto, frecce, chiudi, collega.
export const PlusIcon = material(AddSvg);
export const TrashIcon = material(DeleteSvg);
export const DuplicateIcon = material(ContentCopySvg);
export const RenameIcon = material(EditSvg);
export const DotsIcon = material(MoreVertSvg);
export const EyeIcon = material(VisibilitySvg);
export const EyeOffIcon = material(VisibilityOffSvg);
export const LockIcon = material(LockSvg);
export const LockOpenIcon = material(LockOpenSvg);
export const ChevronIcon = material(ExpandMoreSvg);
export const CloseIcon = material(CloseSvg);
export const LinkIcon = material(LinkSvg);
/** Riporta un valore a quello di partenza: il «reset» dei campi del pannello proprietà. */
export const ResetIcon = material(RestartAltSvg);
/**
 * IL VTO HA LA SUA ICONA, quella con la scritta che usa l'Asset library del DAM: la stessa cosa si riconosce
 * dallo stesso segno nei due posti. Non è una Material, e porta il suo grigio.
 */
export const VtoIcon = VtoSvg;

export { default as EyeMixedIcon } from './eyeMixed.svg';

/**
 * I TRE ASSI, DAL PROTOTIPO (utente, 2026-10-14): fra le Material non c'è un segno che dica «un'origine
 * e tre direzioni», e `3d_rotation` diceva «ruota». È lo stesso glifo per il tasto degli assi nel palco e
 * per un Empty, che è proprio questo — una trasformazione senza superficie. A tratto, come `eyeMixed`:
 * chi lo ospita lo misura col CSS.
 */
export const AxisIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' {...props}>
        <path d='M12 12.3V4' />
        <path d='m10.5 14.5-7 2.5' />
        <path d='m13.5 14.5 7 2.5' />
        <circle cx='12' cy='14' r='1.7' />
    </svg>
);

// SEZIONI, NODI DELL'OUTLINER, LIBRERIE, STRUMENTI DEL VIEWPORT E VISTE.
/**
 * UN OGGETTO DELLA SCENA È `deployed_code` (utente, 2026-10-14), nel rail come nelle righe e nella testata
 * dell'Inspector. Le Material classiche non lo hanno: `deployedCode.svg` è il cubo di Material Symbols,
 * quello della scheda di Google Fonts, senza il nastro sopra.
 */
export const ObjectsIcon = material(DeployedCodeSvg);
export const LightsIcon = material(LightbulbSvg);
export const CamerasIcon = material(VideocamSvg);
export const MaterialsIcon = material(TextureSvg);
export const TexturesIcon = material(WallpaperSvg);
/** L'ambiente intorno alla scena è il globo, lo stesso di «Global» nella barra (utente, 2026-10-14). */
export const EnvironmentsIcon = material(LanguageSvg);
/** Look raccoglie ciò che sta intorno alla scena (round 4): prende il glifo che era di Effects. */
export const LookIcon = material(AutoAwesomeMotionSvg);
/** Color correction: il cerchio a metà del prototipo, che prima era di Post-process. */
export const ColorCorrectionIcon = material(ContrastSvg);
/** Post-process: i livelli, come nel prototipo (D158). */
export const PostProcessIcon = material(LayersSvg);
export const SelectedIcon = material(HighlightAltSvg);
export const EmptyNodeIcon = AxisIcon;
export const MeshNodeIcon = material(ViewInArSvg);
/** «Group» mette le cose in una cartella: il segno è la cartella (utente, 2026-10-14). */
export const GroupIcon = material(FolderSvg);
export const FolderIcon = material(FolderSvg);
export const MoveToIcon = material(DriveFileMoveSvg);
export const UploadIcon = material(UploadSvg);
export const ImportAssetIcon = material(DownloadSvg);
export const SaveAssetIcon = material(SaveSvg);
/** «Dove sta?»: lo slot e la testata dell'Inspector portano all'asset. È il `goTo` del prototipo, `open_in_new`. */
export const RevealIcon = material(OpenInNewSvg);
export const SwapIcon = material(SwapHorizSvg);
export const GlobalSpaceIcon = material(LanguageSvg);
export const LocalSpaceIcon = material(ViewInArSvg);
// IL CURSORE DI SELEZIONE PUNTA IN ALTO A SINISTRA, come il puntatore (prototipo): near_me punta a destra, si specchia.
const NearMeLeftSvg = styled(NearMeSvg)`
    transform: scaleX(-1);
`;
export const SelectToolIcon = material(NearMeLeftSvg);
export const MoveToolIcon = material(OpenWithSvg);
export const RotateToolIcon = material(RotateRightSvg);
export const ScaleToolIcon = material(OpenInFullSvg);
export const FrameSelectionIcon = material(CenterFocusStrongSvg);
export const GridIcon = material(GridOnSvg);
export const ExplodeIcon = material(UnfoldMoreSvg);
export const CollapseIcon = material(UnfoldLessSvg);
/** Espandi e comprimi tutti i rami di un elenco: le stesse frecce, un altro mestiere. */
export const ExpandAllIcon = material(UnfoldMoreSvg);
export const CollapseAllIcon = material(UnfoldLessSvg);
/** «One branch at a time»: una fascia fra due righe, il ramo aperto fra quelli chiusi (prototipo, `solo`). */
export const SingleBranchIcon = material(ViewDaySvg);
export const PreviewModeIcon = material(PreviewSvg);
export const FullscreenIcon = material(FullscreenSvg);
export const FullscreenExitIcon = material(FullscreenExitSvg);
export const ViewGridIcon = material(GridViewSvg);
export const ViewListIcon = material(ViewListSvg);
export const FilterIcon = material(FilterListSvg);
/** La vista libera della sezione Cameras, quella che si usa quando non si guarda da una camera salvata. */
export const FreeCameraIcon = material(VideoCameraFrontSvg);
